import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'ml.quoteandbind.pa.agent.editCoverages.coverages',
        defaultMessage: 'Coverages'
    },
    vehicles: {
        id: 'ml.quoteandbind.pa.agent.editCoverages.vehicles',
        defaultMessage: 'Vehicles'
    },
    coverageTotal: {
        id: 'ml.quoteandbind.pa.agent.editCoverages.coverageTotal',
        defaultMessage: 'Coverage Total'
    },
    vehicleTotal: {
        id: 'ml.quoteandbind.pa.agent.editCoverages.vehicleTotal',
        defaultMessage: 'Vehicle Total'
    },
    addVehicle: {
        id: 'ml.quoteandbind.pa.agent.editCoverages.addVehicle',
        defaultMessage: 'ADD VEHICLE'
    },
});
